module.exports = __webpack_public_path__ + "static/media/visa.3b13df73.svg";